import { useEffect, useRef } from "react";

/**
 * Injects raw Adsterra ad HTML (including <script> tags) into the DOM.
 * Uses createContextualFragment so inline scripts execute in document order,
 * matching how they behave in a static HTML page.
 */
export default function AdsterraBanner({ html, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !html) return;
    try {
      el.innerHTML = "";
      const range = document.createRange();
      range.selectNode(el);
      const fragment = range.createContextualFragment(html);
      el.appendChild(fragment);
    } catch (e) {
      console.warn("AdsterraBanner inject failed:", e);
    }
    // No cleanup needed — ad scripts are self-contained iframes
  }, []); // run once on mount only

  return <div ref={ref} className={className} aria-hidden="true" />;
}
